module.exports = __webpack_public_path__ + "files/2b4454d6e2f687619cbd307e75102078.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/katex/dist/fonts/KaTeX_Fraktur-Bold.eot
 ** module id = 442
 ** module chunks = 0
 **/